import Cookies from 'react-cookies';

class Sounds {
    constructor() {
        this.sounds = {};
        this.sounds_enabled = (Cookies.load('sounds') || "1") == "1";
    }

    play(name) {
        if(typeof this.sounds[name] === 'undefined')
            return;

        this.sounds[name].pause();
        this.sounds[name].currentTime = 0;
        this.sounds[name].play();
    }

    click() {
        if(!this.sounds_enabled)
            return;

        this.play('click');
    }

    gameClick() {
        if(!this.sounds_enabled)
            return;

        this.play('game_open');
    }

    gameOpen() {
        this.sounds.main_theme.pause();
    }

    gameClose() {
        if(this.sounds_enabled)
            this.sounds.main_theme.play();
    }

    toggle(state) {
        if(state === null) {
            this.sounds = window.assets.sounds;
            this.sounds.main_theme.volume = 0.5;

            if(!this.sounds_enabled) {
                this.sounds.main_theme.pause();
            } else {
                this.sounds.main_theme.play();
            }

            this.sounds.main_theme.onended = () => {
                this.sounds.main_theme.currentTime = 0;
                this.sounds.main_theme.play();
            }
        } else {
            this.play('sound_off');
            this.sounds_enabled = state;
    
            if(!this.sounds_enabled) {
                this.sounds.main_theme.pause();
            } else {
                this.sounds.main_theme.play();
            }
        }
    }
}

export default new Sounds();